import { Boundaries } from "@planzone/core";
import { State } from "./types";
import { project } from "@planzone/dto";
import { isInRange } from "./utils";

function handleCreateMilestoneSuccess(
  state: State,
  { milestone, list, project }: Boundaries["createMilestone"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    calendar: {
      ...req.calendar,
      milestones: isInRange(req.filter, {
        startDate: milestone.endDate,
        endDate: milestone.endDate,
      })
        ? [
            ...req.calendar.milestones,
            {
              ...milestone,
              project,
            },
          ]
        : req.calendar.milestones,
    },
  }));
}

export { handleCreateMilestoneSuccess };
